/*
 * Copyright (c) 2022
 *
 * Created Date: Tuesday, September 20th 2022, 1:35:46 pm
 * Author: Muhammad Fajariansyah Ismail
 *
 */

import "bootstrap/dist/css/bootstrap.min.css";
import "react-circular-progressbar/dist/styles.css";
import "react-loading-skeleton/dist/skeleton.css"

// import './index.css';
import "./i18n";
import "./assets/scss/stylesheet.scss";

import App from "routes/App";
import React from "react";
import ReactDOM from "react-dom/client";
import { Toaster } from "react-hot-toast";

import reportWebVitals from "./reportWebVitals";
import { CookiesProvider } from 'react-cookie';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<>
    <div>
        <Toaster containerClassName="luna-hot-toast" toastOptions={{ 
            success: {
                duration:5000
            },
            error: {
                duration:5000
            }
        }} />
    </div>
    <CookiesProvider>
        <App />
    </CookiesProvider>
</>);

// i am disabling this strict mode cause react-player having issue in development when strict mode enalble
// strict mode doesn't affect on production, it will disable automatically
// root.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>
// );

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
